<template>
    <div id="wmap">
      <l-map
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        ref="vueMap"
      >
  
        <l-tile-layer :url="url" />
        <l-marker
          :key="index"
          v-for="(location, index) in locations"
          :lat-lng="setLatLong(location.coordinates)"
          @click="innerClick(location)"
        />   
      </l-map>
        
    </div>
</template>

<script>

import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import { Icon, latLng } from "leaflet";
import { serviceBus } from "../main";

export default {
  name: "MyMap",
  props:{
    locations: Object,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data: function() {
    return {
      myMap: null,
      url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      currentMarker: 0,
      zoom: 2.5,
      currentZoom: 3,
      center: latLng(44.411595, 8.929963),
      currentCenter: latLng(44.411595, 8.929963),
      coords: latLng(47.41322, -1.219482),
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 9,
        minZoom: 2
      },
    };
  },
  computed: {
    location(){
      return this.$store.getters.getLocation.name
    }
  },
  mounted: async function() {
    this.loadIcon();5
    this.$nextTick(() => { this.myMap = this.$refs.vueMap.mapObject; });
    
  },
  watch:{
    currentMarker: function(){
      serviceBus.$emit('updateCity', this.currentMarker);
    }, 
    location(){
      console.log("he cambiado")
    }
  },
  created(){
    serviceBus.$on('cardClicked', (cityID)=>{
      this.moveMap(this.locations[cityID]);
    })
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    markerUpdate(location){
      if (location != this.currentMarker){
        this.currentMarker = location;
      }
    },
    moveMap(location){ // from card
      this.markerUpdate(location);
      this.myMap.setView(this.setLatLong(location.coordinates), 6);
    },
    innerClick(location) { //from marker
      this.markerUpdate(location);
      this.$store.commit('setLocation', location);      
      this.moveMap(location);
      serviceBus.$emit('markerClicked');
      // mueveCard
    },
    loadIcon() {
      delete Icon.Default.prototype._getIconUrl;
      Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
      });
    },
    setLatLong(coordString) {
      let lat, long;
      [lat, long] = coordString.split(",");
      return latLng(lat, long);
    }
  }
};
</script>

<style lang="scss" scoped >
#wmap {
  height: 90vh;
  width: 80vw;
}

</style>